import { render, staticRenderFns } from "./newCenterDetil.vue?vue&type=template&id=7c754fa2&scoped=true"
import script from "./newCenterDetil.vue?vue&type=script&lang=js"
export * from "./newCenterDetil.vue?vue&type=script&lang=js"
import style0 from "./newCenterDetil.vue?vue&type=style&index=0&id=7c754fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c754fa2",
  null
  
)

export default component.exports